import {
  HttpInterceptorFn,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse,
  HttpHandlerFn
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ToasterService } from '../providers/toaster/toaster.service';
import { CancelApiServiceService } from '../auth/cancel-api-service.service';


export const apiInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<any> => {
  const auth = inject(AuthService);
  const toasterService = inject(ToasterService);
  const cancelService = inject(CancelApiServiceService);

  // Clone the request to add auth token and headers
  const token = auth.getToken();
  let modifiedReq = req;

  if (token) {
    modifiedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  if (!(req.body instanceof FormData)) {
    modifiedReq = modifiedReq.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    });
  }

  return next(modifiedReq).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        console.log('API Response:', event);
      }
    }),
    takeUntil(cancelService.cancel$),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        toasterService.setToaster('error', 'HTTP : Session Expired', 'The session has expired. Please log in again.');
        cancelService.cancelRequests();
        auth.logout();
      } else if (error.status === 403) {
        toasterService.setToaster('error', 'HTTP : Access Denied', 'You do not have permission to access this resource.');
      } else if (error.status === 404) {
        console.error('API Endpoint Not Found:', error.url);
      } else if (error.status === 500) {
        toasterService.setToaster('error', 'HTTP : Server Error', 'An error occurred on the server.');
      } else {
        toasterService.setToaster('error', 'HTTP : Error', 'An error occurred.');
      }
      return throwError(() => error);
    }),

    finalize(() => {

    })
  );
};